module.exports = __webpack_public_path__ + "static/media/app-bar-logo.8b510ec1.svg";